// extracted by mini-css-extract-plugin
export default {"bold-header":"sent-seeds_bold-header__f1IHi","oddRow":"sent-seeds_oddRow__v1-4L","oddRowLight":"sent-seeds_oddRowLight__sdMqJ","evenRowLight":"sent-seeds_evenRowLight__RjkmZ"};